<template>
    <el-container direction="vertical">
        <el-col justify="start" class="pr10">
            <el-form :model="expense" label-position="top">
                <div class="expense-main">
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Дата создания
                        </el-col>
                        <el-col :span="16">
                            {{ expense.created_at }}
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Создатель
                        </el-col>
                        <el-col :span="16">
                            <el-select
                                v-model="expense.created_by_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                :placeholder="expense.created_by_full_name"
                                size="mini"
                            >
                                <el-option v-for="item in employersList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            ID сделки
                        </el-col>
                        <el-col :span="16">
                            {{ getExpenseDealId }}
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Договор
                        </el-col>
                        <el-col :span="16">
                            {{ getContractNumber }}
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Адрес
                        </el-col>
                        <el-col :span="16">
                            {{ getDealAddress }}
                        </el-col>
                    </el-row>
                    <div class="mb10" v-for="value in expense.details" :key="value.id">
                        <el-row class="mb10">
                            <el-col :span="8" class="gray">
                                Статья
                            </el-col>
                            <el-col :span="8" class="gray">
                                <el-select
                                    v-model="value.expense_type"
                                    placement="bottom"
                                    popper-class="popper-dropdown"
                                    collapse-tags
                                    size="mini"
                                >
                                    <el-option v-for="item in expenseTypeList" :key="item.id" :label="item.name" :value="item.id" />
                                </el-select>
                            </el-col>
                            <el-col :span="4" class="gray">
                                <span class="expense-type-amount">Сумма,руб</span>
                            </el-col>
                            <el-col :span="4" class="gray">
                                <auto-numeric
                                    v-model="value.amount"
                                    :options="getNumericOptions(value.expense_type)"
                                    :class="[
                                        'autonumeric'
                                    ]"
                                />
                            </el-col>
                        </el-row>
                    </div>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Получено у - тип контрагента
                        </el-col>
                        <el-col :span="16">
                            {{ this.getName(this.receivedFromTypesList, expense.recipient_type) }}
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Получил
                        </el-col>
                        <el-col :span="16">
                            <el-select
                                v-model="expense.recipient_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in receivedByIdList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Отчётный период
                        </el-col>
                        <el-col :span="14" class="period-select">
                            <div class="filter-label">
                                Год
                            </div>
                            <el-select
                                v-model="expense.period_year"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                placeholder="Год"
                                size="mini"
                                class="period-select-year"
                            >
                                <el-option v-for="item in localReferences.yearsList" :key="item" :label="item" :value="item" />
                            </el-select>
                            <div class="filter-label">
                                Месяц
                            </div>
                            <el-select
                                v-model="expense.period_month"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                clearable
                                placeholder="Месяц"
                                size="mini"
                                class="period-select-month"
                            >
                                <el-option v-for="item in localReferences.monthsList" :key="item" :label="item" :value="item" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="mb10">
                        <el-col :span="8" class="gray">
                            Сумма,руб
                        </el-col>
                        <el-col :span="16">
                            {{ formatFinance(calculateAmount) }}
                        </el-col>
                    </el-row>
                    <el-row class="text-center pt16">
                        <el-col>
                            <el-button type="warning" @click="save">
                                Применить
                            </el-button>
                            <el-button type="info" @click="close">
                                Отменить
                            </el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </el-col>
    </el-container>
</template>
<script>
import AutoNumeric from '@/components/autonumeric/VueAutonumeric';
import ExpenseMixin from '@/mixins/expense';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { pickerOptions } from '@/common/pickerOptions';
import moment from 'moment';
import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';
import '@/assets/styles/card.scss';
import { formatFinance } from '@/common/utilities';

const initialExpense = {
    id: null,
    created_by_id: null,
    created_at: moment().format('DD.MM.YYYY HH:mm'),
    amount: 0,
    amount_formatted: ''
};

export default {
    name: 'ExpenseDealEdit',
    components: {
        AutoNumeric
    },
    mixins: [
        ExpenseMixin
    ],
    props: {
        id: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            expense: {},
            created_by_name: '',
            errors: [],
            loadingMain: false,
            period: [],
            isSaveButtonPressed: false,
            counter: 0,
            amount: 0
        };
    },
    computed: {
        calculateAmount() {
            let amount = 0;
            if (this.expense.details !== undefined) {
                amount = this.expense.details.reduce((previousValue, currentValue) => previousValue + currentValue.amount, amount);
            }
            return amount;
        },
        isEdit() {
            return true;
        },
        getExpenseDealId() {
            if (this.expense.deal !== undefined) {
                return this.expense.deal.id;
            }
            return '';
        },
        getContractNumber() {
            if (this.expense.deal !== undefined) {
                return this.expense.deal.contract_number;
            }
            return '';
        },
        getDealAddress() {
            if (this.expense.deal !== undefined) {
                return this.expense.deal.address;
            }
            return '';
        }
    },
    mounted() {
        if (!this.isNew) {
            this.getExpense();
        }
    },
    methods: {
        formatFinance,
        async getExpense() {
            this.loadingMain = true;
            try {
                this.expense = await this.$store.dispatch('expenses/getExpense', this.id);
            } catch (error) {
                console.log(error);
            } finally {
                this.loadingMain = false;
            }
        },
        getOfficeName() {
            const expense = this.expense;
            if (expense.deal !== null) {
                return expense.deal.responsible_user.office_name;
            }
        },
        open() {
            return true;
        },
        close() {
            this.$emit('closePopUp', false);
        },
        async updateExpense() {
            this.loadingMain = true;
            try {
                var amount = 0;
                this.expense.details.forEach(detail => {
                    amount += detail.amount;
                });
                this.expense.amount = amount;
                this.expense.report_date = this.getPeriod();
                this.expense = await this.$store.dispatch('expenses/updateExpense', { ...this.expense });
                this.actionAfterSave();
                this.$emit('getDataFromServer');
            } catch (e) {
                this.errors = JSON.parse(e.message);
                this.actionAfterSaveError();
            } finally {
                this.loadingMain = false;
                this.isSaveButtonPressed = false;
            }
        },
        save() {
            if (this.isSaveButtonPressed) {
                return;
            }
            this.isSaveButtonPressed = true;
            this.updateExpense();
        },
        actionAfterSave() {
            this.$message({
                showClose: true,
                message: 'Расход сохранён',
                type: 'success',
                duration: 5000,
                customClass: this.alertClass()
            });
            this.$emit('closePopUp', false);
        },
        actionAfterSaveError() {
            this.$message({
                showClose: true,
                message: 'Расход не сохранён',
                type: 'error',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        getNumericOptions(expenseType) {
            if (expenseType === 'fine_deal') {
                return [this.numericOptions, { minimumValue: '-9999999999999', maximumValue: 0 }];
            }
            if (expenseType === 'complaint_work' || expenseType === 'complaint_materials') {
                return [this.numericOptions, { minimumValue: '-9999999999999' }];
            }
            return this.numericOptions;
        }
    }
};
</script>
